<template>
  <div o-Container o-Container-App>
    <van-nav-bar :title="title" left-arrow @click-left="back" />
    <van-field
      class="phone"
      v-model="phone"
      type="tel"
      center
      clearable
      label="手机号"
      placeholder="手机号码"
    >
      <template #button>
        <van-button
          v-show="show"
          size="small"
          type="primary"
          @touchstart="getCode"
          >发送验证码</van-button
        >
        <van-button v-show="!show" size="small" type="primary"
          >{{ count }} s</van-button
        >
      </template>
    </van-field>
    <van-field
      class="smscode"
      v-model="smsCode"
      type="number"
      center
      clearable
      label="验证码"
      placeholder="短信验证码"
    >
    </van-field>
    <van-field
      class="password"
      v-model="passWord"
      type="password"
      clearable
      label="密码"
      placeholder="超过包含字母和数字的8个字符"
    />
    </van-field>
    <div class="register" @click="onSubmit">注册</div>
    <div class="agreement">
      <span>注册即同意</span>
      <span class="green" @click="getAgreement">《GDSmart用户协议》</span>
      <span>和</span>
      <span class="green" @click="getPrivacy">《GDSmart隐私政策》</span>
    </div>
  </div>
</template>

<script>
import PageBackVue from "../../Monitor/Main/PageBack.vue";
import axios from 'axios/dist/axios.js'

export default {
  name:
    "app_en_database_item" /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */,
  data() {
    return {
      octopus: this.$parent.octopus,
      title: "注册",
      passWord: "",//密码
      phone: "",//手机
      smsCode: "",//验证码
      show: true,//是否显示
      timer: null,//定时器
      count: "",//时间倒计时数
      timeStamp: "",
    };
  },
  deactivated: function () {
    this.phone = "";
    this.passWord = "";
    this.smsCode = "";
    // this.rePassWord = "";
  },
  methods: {
    //返回上一个洁面
    back: function () {
      window.history.go(-1);
    },
    //注册
    register: function () {
      let o = this;
      axios.post(this.octopus.config.url + "/ESB/user/register",{
        mobile: this.phone,
        password: this.passWord,
      })
      .then(function(res){
          if (res.data.status.code == 200) {
            o.octopus.tips.success("注册成功");
            o.back();
          } else {
            o.octopus.tips.error(res.data.status.message );
          }
      })
      .catch(function(err){
      });
    },
    //获取验证码
    getCode() {
      let o = this;
      if (this.phone.length !== 11) {
        this.octopus.tips.success("请输入正确的手机号");
        return;
      }
      this.timeStamp = Date.now();
      axios.post(this.octopus.config.url + "/ESB/Tools/Verify/getVerifyCode",{
        verifyBusiness:1,
        phoneNumber: this.phone,
        timeStamp: this.timeStamp,
      })
      .then(function(res){
        if (res.data.status.code == 200) {
            o.octopus.tips.success(res.data.content.description);
            o.octopus.tips.success("发送成功");
            o.changeBtn();
          }
      })
      .catch(function(err){
        console.log(err);
      });
    },
    changeBtn() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 注册前置审核
    login: function () {
      // 提交的时候判断是否是已经加密，如果没有，则提交登录的时候对数据进行加密。
      if (!this.octopus.passport.encryption) {
        // 更新时间戳（毫秒）
        this.octopus.passport.timespan = new Date().valueOf();
        this.octopus.passport.password = this.octopus.tools.md5(
          this.octopus.passport.name +
            "marco" +
            this.octopus.passport.timespan +
            "july" +
            this.octopus.passport.password
        );
      }
    },
    //隐私
    getPrivacy() {
      this.octopus.router.jump("/APP/Main/Privacy/Page");
    },
    //协议
    getAgreement() {
      this.octopus.router.jump("/APP/Main/Agreement/Page");
    },

    //点击注册需要先验证二维码正确与否
    onSubmit() {
      let o = this;
      //手机号是否是11位
      if (this.phone.length !== 11) {
        this.octopus.tips.success("请输入手机号");
        return;
      }
      //正则密码
      let exp = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/;
      if(this.passWord === ''  || !exp.test(this.passWord)){
          this.octopus.tips.success('请输入符合规制得新密码');
          return;
      }
      //判断密码
      if(this.smsCode.length !== 6){
        this.octopus.tips.success("请输入验证码");
        return;
      }
      //axios吊起
      axios.post(this.octopus.config.url + "/ESB/Tools/Verify/checkVerifyCode",{
        verifyBusiness: 1,
        phoneNumber: this.phone,
        timeStamp: this.timeStamp,
        code: this.smsCode,
      })
      .then(function(res){
        if (res.data.status.code == 200) {
            // o.octopus.tips.success("sms验证成功");
            // 继续注册
            o.register();
        } else {
            o.octopus.tips.success("请重新获取验证码");
        }
      })
      .catch(function(err){
        // o.octopus.tips.success(err.content.description);
      });

    },
  },
  props: ["oData"],
};
</script>



// WEBPACK FOOTER //
// src/components/APP/Main/Register/Page.vue